export const textStyles = {
  muted: {
    color: "gray.500",
  },
  mutedPrint: {
    fontStyle: "italic",
  },
};
